import React, { useState, useEffect } from 'react'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import axios from 'axios'

// Function to fetch events from the API
async function fetchEvents() {
    try {
        const storedToken = localStorage.getItem("token")
        if (!storedToken) {
            // console.log("Access required");
            return [];
        }

 
        const url = `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-batches`;

        const response = await axios.get(url, {
            headers: { Authorization: `Bearer ${storedToken}` },
        });
        // only ongoing bath display
        // console.log("response", response.data.data.upcoming);
        
        // Assuming the response contains an 'ongoing' array with event objects
        return response.data.data.upcoming.map(event => ({
            id: event._id,
            title: event.batch_name,
            start: event.batch_start_duration, // Ensure this is in ISO 8601 format
            end: event.batch_end_duration, // Ensure this is in ISO 8601 format
        }));
    } catch (error) {
        console.error('Error fetching events:', error);
        return [];
    }
}

export default function Calendar() {
    const [events, setEvents] = useState([]); // State to store fetched events

    // Fetch events when the component mounts
    useEffect(() => {
        async function loadEvents() {
            const fetchedEvents = await fetchEvents();
            setEvents(fetchedEvents); // Update state with fetched events
        }

        loadEvents();
    }, []); // Empty dependency array means this runs once when the component mounts

    function handleDateSelect(selectInfo) {
        let title = prompt('Please enter a new title for your event')
        let calendarApi = selectInfo.view.calendar

        calendarApi.unselect()

        if (title) {
            const newEvent = {
                id: String(new Date().getTime()), // Generate a unique ID based on current timestamp
                title,
                start: selectInfo.startStr,
                end: selectInfo.endStr,
                allDay: selectInfo.allDay
            }
            setEvents([...events, newEvent]) // Add the new event to the list
            calendarApi.addEvent(newEvent) // Add the event to the calendar
        }
    }

    function handleEventClick(clickInfo) {
        // eslint-disable-next-line no-restricted-globals
        if (confirm(`Are you sure you want to delete the event '${clickInfo.event.title}'`)) {
            setEvents(events.filter(event => event.id !== clickInfo.event.id)) // Remove from the list
            clickInfo.event.remove() // Remove from the calendar
        }
    }

    return (
        <div className='demo-app'>
            <div className='demo-app-main'>
                <FullCalendar
                    plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                    headerToolbar={{
                        left: 'title',
                        center: 'timeGridDay,timeGridWeek,dayGridMonth',
                        right: 'prev,next today'
                    }}
                    initialView='dayGridMonth'
                    editable={true}
                    selectable={true}
                    selectMirror={true}
                    dayMaxEvents={true}
                    weekends={true}
                    events={events} // Pass the dynamic events fetched from API
                    // select={handleDateSelect}
                    eventContent={renderEventContent}
                    // eventClick={handleEventClick}
                />
            </div>
        </div>
    )
}

function renderEventContent(eventInfo) {
    return (
        <>
            <b>{eventInfo.timeText}</b>
            <i>{eventInfo.event.title}</i>
        </>
    )
}
